module.exports = __webpack_public_path__ + "static/media/Rubik-Black.5bcba2e6.ttf";